<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content [innerHTML]="message">
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="onConfirm()" *ngIf="!buttons">Ja</button>
  <ng-container *ngIf="buttons">
    <button *ngFor="let button of buttons" mat-raised-button [color]="button.color" (click)="onConfirm(button.value)">{{ button.label }}</button>
  </ng-container>
</div>
